export const LOCAL_STORAGE_ACCESS_TOKEN_KEY = 'easyBackOfficeAccessToken';
export const LOCAL_STORAGE_REFRESH_TOKEN_KEY = 'easyBackOfficeRefreshToken';
